// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3wHzr","insightsList":"newBusinessInsightsMenu_insightsList__3MLlw","active":"newBusinessInsightsMenu_active__gdoOY"};